import { combineReducers, configureStore } from '@reduxjs/toolkit';
import themeConfigSlice from './themeConfigSlice';
import authSlice from './authSlice';
import realtimeSlice from './realtimeSlice';
import notificationsSlice from './notificationsSlice';
import lojaCartSlice from './lojaCartSlice';

const rootReducer = combineReducers({
    themeConfig: themeConfigSlice,
    auth: authSlice,
    realtime: realtimeSlice,
    notifications: notificationsSlice,
    lojaCart: lojaCartSlice,
});

const store = configureStore({
    reducer: rootReducer,
});

export default store;

export type IRootState = ReturnType<typeof rootReducer>;

/** Dispatch que aceita thunks — `useDispatch()` sem tipo só aceita action pura. */
export type AppDispatch = typeof store.dispatch;
